<template>
  <div class="select">
    <select v-model="clone" :aria-labelledby="label" class="select__input">
      <slot></slot>
    </select>
    <Caret />
  </div>
</template>
<script>
  import { defineComponent, computed } from '@vue/composition-api'
  import Caret from '@/components/icons/Caret'

  export default defineComponent({
    components: { Caret },
    model: {
      event: 'change',
    },
    props: {
      label: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Number],
        default: '',
      },
    },
    setup(props, { emit }) {
      const clone = computed({
        get: () => props.value,
        set: (value) => emit('change', value),
      })

      return { clone, emit }
    },
  })
</script>

<style lang="scss" scoped>
  .select {
    position: relative;

    .icon {
      position: absolute;
      right: spacer(0.5);
      top: 0.8rem;
      height: 1.2em;
      width: 1em;
      pointer-events: none;
      transform: rotate(180deg);
    }
  }

  .select__input {
    width: 100%;
    height: 2.5rem;
    appearance: none;
    border: 0;
    color: inherit;
    border-bottom: 2px solid $grey-dark;
    background-color: transparent;
    padding: 0;
  }
</style>
